<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="(type==='edit' ? '修改': '新增') + '子卡'"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="420px"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form @sub="sub" :noSubBtn="true" ref="customForm" :formData="formData">
        <section slot="chooseVehicle" slot-scope="prop" class>
          <ChooseVehicle
            style="display: inline-block"
            :isRadio="true"
            v-model="prop.form.chooseVehicle"
          />
        </section>
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
      >确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  // oilDetail,
  doQueryParent,
  saveOrUpdateOilCard,
} from 'api/service';
import {
  getEnumList,
} from 'api';
import ChooseVehicle from 'components/choose/vehicle';
export default {
  components: {
    ChooseVehicle,
  },
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        cardTypeOptions: [],
        parentCardIdOptions: [],
        oilCardStatusOptions: [],
        form: [
          {
            label: '来源类型',
            value: 'cardType',
            type: 'select',
            placeholder: '请选择来源类型',
          },
          {
            label: '主卡卡号',
            value: 'parentCardId',
            type: 'select',
            placeholder: '请选择主卡卡号',
            onChange: () => {
              this.onChnageParentCard();
            },
          },
          {
            label: '服务商',
            value: 'companyName',
            type: 'input',
            hide: true,
            readonly: true,
          },
          {
            label: '油卡类型',
            value: 'oilCardTypeName',
            type: 'input',
            hide: true,
            readonly: true,
          },
          {
            label: '类型备注',
            value: 'cardTypeRemark',
            type: 'input',
            placeholder: '请输入类型备注',
            hide: true,
            readonly: true,
          },
          {
            label: '子卡卡号',
            value: 'oilCarNum',
            type: 'input',
            placeholder: '请输入子卡卡号',
          },
          // {
          //   label: '油卡状态',
          //   value: 'oilCardStatus',
          //   type: 'select',
          //   default: -1,
          //   placeholder: '请输入油卡状态',
          // },
          {
            label: '理论余额',
            value: 'cardBalance',
            type: 'input',
            placeholder: '请输入理论余额',
            unit: '元',
          },
          {
            label: '绑定车辆',
            value: 'chooseVehicle',
            default: {},
            slot: true,
            placeholder: '请选择绑定车辆',
          },
          {
            label: '油卡类型',
            value: 'oilCardType',
            type: 'input',
            hide: true,
          },
          {
            label: '服务商ID',
            value: 'userId',
            type: 'input',
            hide: true,
          },
        ],
        rules: {
          cardType: [
            { required: true, message: '请选择来源类型', trigger: 'blur' },
          ],
          parentCardId: [
            { required: true, message: '请选择主卡卡号', trigger: 'blur' },
          ],
          oilCarNum: [
            { required: true, message: '请输入子卡卡号', trigger: 'blur' },
          ],
          oilCardStatus: [
            { required: true, message: '请输入油卡状态', trigger: 'blur' },
          ],
          cardBalance: [
            { required: true, message: '请输入理论余额', trigger: 'blur' },
          ],
          chooseVehicle: [
            { required: true, message: '请选择绑定车辆', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$refs.customForm && this.$refs.customForm.reset();
      await this.getFormSelectList();
      if (item) { // 修改
        this.type = 'edit';
        this.originData = item;
        this.setFormVal(item);
      } else { // 新增
        this.type = 'add';
      }
      if (this.$route.path.includes('gasCard')) {
        this.$nextTick(() => {
          this.formData.form.forEach((item) => {
            if (item.label.includes('油卡')) {
              item.label = item.label.replace(/油卡/g, '气卡');
            }
            if (item.placeholder && item.placeholder.includes('油卡')) {
              item.placeholder = item.placeholder.replace(/油卡/g, '气卡');
            }
            Object.keys(this.formData.rules).forEach((item) => {
              if (this.formData.rules[item][0].message.includes('油卡')) {
                this.formData.rules[item][0].message = this.formData.rules[item][0].message.replace(/油卡/g, '气卡');
              }
            });
          });
        });
      }

    },

    async setFormVal (item) {
      this.$refs.customForm.setVal('cardType', `${item.cardType}`);
      this.$refs.customForm.setVal('parentCardId', item.parentCardId);
      this.$refs.customForm.setVal('oilCarNum', item.oilCarNum);
      this.$refs.customForm.setVal('oilCardStatus', `${item.oilCardStatus}`);
      this.$refs.customForm.setVal('cardBalance', item.cardBalance / 100);
      this.$refs.customForm.setVal('chooseVehicle', {
        plateNumber: item.plateNumber,
      });
      this.onChnageParentCard();
    },

    async getFormSelectList () {
      this.setFormAttrVal({ // 姓名
        form: this.formData,
        attr: 'hide',
        value: true,
        names: ['companyName', 'oilCardTypeName'],
      });
      const enumList = await getEnumList({
        codeType: 'OIL_CARD_TYPE,OILCARD_STATUS,GAS_CARD_TYPE',
      });
      const resParents = await doQueryParent({
        cardCategory: this.$route.path.includes('gasCard') ? 2 : 1,
      });
      let parentCardIdOptions = [];
      if (resParents && resParents.items.length) {
        for (let item of resParents.items) {
          parentCardIdOptions.push({
            ...item,
            label: item.oilCarNum,
            value: item.cardId,
          });
        }
      }
      if (enumList && enumList.length) {
        this.formData.cardTypeOptions = this.$route.path.includes('gasCard') ? enumList[2] : enumList[0] ;
        this.formData.oilCardStatusOptions = enumList[1];
        this.$refs.customForm.setVal('cardType', this.formData.cardTypeOptions[0].value);
        this.$refs.customForm.setVal('oilCardStatus', this.formData.oilCardStatusOptions[0].value);
      }
      if (parentCardIdOptions.length) {
        this.formData.parentCardIdOptions = parentCardIdOptions;
        this.setCompanyNameAndOilCardTypeName(0);
      }
    },

    onChnageParentCard () {
      if (this.formData.parentCardIdOptions.length) {
        const parentCardId = this.$refs.customForm.getVal('parentCardId');
        const index = this.formData.parentCardIdOptions.findIndex((item) => item.cardId === parentCardId);
        this.setCompanyNameAndOilCardTypeName(index);
      }
    },

    setCompanyNameAndOilCardTypeName (index) {
      const parentCardId = this.formData.parentCardIdOptions[index];
      if (parentCardId) {
        this.$refs.customForm.setVal('parentCardId', parentCardId.value);
        this.setFormAttrVal({
          form: this.formData,
          attr: 'hide',
          value: false,
          names: ['companyName', 'oilCardTypeName'],
        });
        this.$refs.customForm.setVal('companyName', parentCardId.companyName);
        this.setFormAttrVal({
          form: this.formData,
          attr: 'hide',
          value: parentCardId.oilCardType !== 6,
          names: ['cardTypeRemark'],
        });

        this.$refs.customForm.setVal('oilCardTypeName', parentCardId.oilCardTypeName);
        this.$refs.customForm.setVal('cardTypeRemark', parentCardId.cardTypeRemark);

        this.$refs.customForm.setVal('oilCardType', parentCardId.oilCardType);
        this.$refs.customForm.setVal('userId', parentCardId.userId);
      }
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      // 是否主卡
      const vehicleInfo = this.$refs.customForm.getVal('chooseVehicle');
      form.isParent = 0;
      form.vehicleNumberStr = vehicleInfo.plateNumber;
      // form.cardBalance = form.cardBalance*100;
      form.cardId = this.type === 'edit' ? this.originData.cardId : 0;
      form.cardCategory = this.$route.path.includes('gasCard') ? 2 : 1;
      delete form.chooseVehicle;
      console.log(form);
      this.subLoading = true;
      const res = await saveOrUpdateOilCard(form);
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
